/**************************************************
 * Nombre:       Formacion_Centro
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import fondo from '../../../Recursos/fondo_oficinas.png'
import logo from '../../../Recursos/logo_blanco.svg'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {irUrl} from "../../../Utilidades/irUrl";

const Formacion_Centro = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: `linear-gradient(180deg, rgba(48, 51, 118, 0.85) 0%, rgba(48, 51, 118, 0.85) 100%), url(${fondo})`,
                backgroundPosition: 'center center',
                backgroundSize: 'cover',
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff', py: 10}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <img src={logo} width={350} height={'auto'}/>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 6}}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',mt: sCell ? 4 : 0}}>
                                <Typography sx={{fontWeight: 300}}>
                                    El Centro de Conciliación, Arbitraje, Amigable Composición e Insolvencia Solución de
                                    Conflictos para la Paz, dirigido por la doctora Monica Yiseth López E y la
                                    coordinación de Melissa Rosales Dueñas es una entidad avalada por el Ministerio de
                                    Justicia bajo la Resolución No. 2288 del 26 de diciembre del 2023. Estamos a la
                                    vanguardia de lo que exige el Decreto 0042 del 21 de enero del 2026 del Ministerio
                                    de Justicia y del Derecho, manteniendo nuestra misión de certificar a profesionales
                                    y estudiantes como conciliadores idóneos ante el SICAAC, fundamentándonos en el
                                    Estatuto de Conciliación (Ley 2220 de 2022).
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 8}}>
                                <Button
                                    onClick={() => irUrl(item.pdf)}
                                    variant={'outlined'} color={'info'}>Descargar Documento Completo</Button>
                            </Grid>

                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Formacion_Centro  